import React from 'react';

import BLOCK_RIZ_CONFIG from 'shared-constants/src/blockRizConfig';
import { getItem, setItem } from '../localStorage';
import blockRizLogic from '../blockRizLogic';

import openFeedbackModal from './openFeedbackModal';

const getLocationIds = (locations) => {
  let formattedAsIDs = [];
  locations.forEach((loc) => formattedAsIDs.push(loc.id));
  formattedAsIDs = formattedAsIDs.join('|');
  return formattedAsIDs !== '' ? `|${formattedAsIDs}|` : '';
};

export const sendGenericLeadCallBack = async ({
  response,
  userData,
  modalTitle,
  closeModal,
  openModalAction,
  closeModalAction,
  createFeedbackModal,
  setUserFormDataAction,
  filters,
  locations,
}) => {
  const success = response.data && response.data.code === 201;

  // update user formData
  setUserFormDataAction && await setUserFormDataAction({
    consent: userData.consent,
    email: userData.email,
    firstName: userData.firstName,
    lastName: '',
    telephone: userData.telephone || '',
  });

  await closeModalAction({ close: closeModal });

  setTimeout(() => {
    if (success) {
      /* TECH-5965 */
      const rizStorageArray = getItem('csa_riz_to_block') || [];
      const rizData = {
        email: userData.email,
        channel: filters.channel || '',
        category: filters.category || '',
        propertyTypeGroup: filters.propertyTypeGroup || '',
        locationCode: getLocationIds(locations),
      };
      const { newRizStorageArray } = blockRizLogic(
        rizStorageArray,
        rizData,
        BLOCK_RIZ_CONFIG,
      );
      setItem('csa_riz_to_block', newRizStorageArray);
      /* TECH-5965 */

      openFeedbackModal({
        openModalAction,
        createFeedbackModal,
        isMobile: false,
        fail: false,
        failMethod: null,
        feedback: (
          <>
            <p className="rizmdl__txt tp-s--l tp-w--m c-txt--f0 tp-a--c mb--m">
              Grazie!
            </p>
            <p className="rizmdl__txt tp-s--m tp-w--s c-txt--secondary tp-a--c">
              La richiesta è stata inviata con successo
            </p>
          </>
        ),
        title: modalTitle,
      });
    } else {
      // INVIO SPECIFICA FALLITO

      // mostriamo la failure
      openFeedbackModal({
        openModalAction,
        createFeedbackModal,
        isMobile: false,
        fail: true,
        failMethod: null,
        feedback: (
          <p className="rizmdl__txt--err tp-s--l tp-w--m c-txt--f0 tp-a--c mb--m">
            Oops... qualcosa è andato storto!
            <br />
            Invia di nuovo la richiesta.
          </p>
        ),
        title: modalTitle,
      });
    }
  }, 301);
};

export default ({
  openModalAction,
  closeModalAction,
  createGenericModal,
  createFeedbackModal,
  setUserFormDataAction = null,
  leadConf,
}) => {
  const {
    device,
    mainLocation,
    additionalLocations,
    filters,
    getActiveFilters,
    getHumanFilters,
    getPtypesPlurals,
    getPreviewFromFilters,
    user,
  } = leadConf;

  openModalAction(createGenericModal({
    device,
    mainLocation,
    additionalLocations,
    filters,
    getActiveFilters,
    getHumanFilters,
    getPtypesPlurals,
    getPreviewFromFilters,
    user,
    sendGenericLeadCallBack,
    sendGenericLeadCallBackPayload: {
      openModalAction,
      closeModalAction,
      createFeedbackModal,
      setUserFormDataAction,
    },
  }));
};
